/* Hexdeck – collection & search filtering via the Section Rendering API.
   On the Singles collection the singles search also filters the grid in place:
   the page URL keeps a plain ?q=term, results are rendered from /search through
   sections/singles-search-results.liquid. */
(() => {
  const root = document.querySelector('[data-facets-section]');
  if (!root) return;
  const $ = (s, r = document) => r.querySelector(s);
  const H = window.Hexdeck || {};
  const sectionId = root.dataset.sectionId;
  const searchSection = root.dataset.searchSection;
  const searchScope = root.dataset.searchScope || '';
  const cols = root.dataset.cols;
  const basePath = window.location.pathname;
  const searchPath = new URL((H.routes && H.routes.search) || '/search', window.location.origin).pathname;
  const singlesInput = searchSection ? $('[data-singles-filter] [data-singles-input]') : null;
  const home = $('[data-facets-home]', root);
  const drawer = document.querySelector('[data-facets-drawer]');
  const drawerBody = drawer && $('[data-facets-drawer-body]', drawer);
  const getForm = () => document.querySelector('[data-facets-form]');

  let controller;
  let lastTerm = '';
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const currentTerm = () => (singlesInput ? singlesInput.value.trim() : '');

  // Every word must match the title, card ID (SKU) or a tag (e.g. champion).
  function buildQuery(term) {
    const words = term.replace(/[():*"]/g, ' ').split(/\s+/).filter(Boolean);
    return [searchScope, ...words.map((w) => `(title:${w}* OR variants.sku:${w}* OR tag:${w})`)].filter(Boolean).join(' AND ');
  }

  // Links rendered by the search section point at /search – map them back onto this collection.
  function toPageUrl(href) {
    const u = new URL(href, window.location.origin);
    if (!searchSection || u.pathname !== searchPath) return `${u.pathname}${u.search}`;
    const params = new URLSearchParams();
    u.searchParams.forEach((v, k) => { if (!['q', 'type', 'options[prefix]', 'section_id'].includes(k)) params.append(k, v); });
    const term = currentTerm();
    if (term) params.set('q', term);
    return `${basePath}?${params.toString()}`;
  }

  function toFetchUrl(pageUrl) {
    const u = new URL(pageUrl, window.location.origin);
    const term = (u.searchParams.get('q') || '').trim();
    if (searchSection && term) {
      const s = new URL(searchPath, window.location.origin);
      u.searchParams.forEach((v, k) => { if (k !== 'q') s.searchParams.append(k, v); });
      s.searchParams.set('q', buildQuery(term));
      s.searchParams.set('type', 'product');
      s.searchParams.set('options[prefix]', 'last');
      s.searchParams.set('section_id', searchSection);
      return s;
    }
    u.searchParams.set('section_id', sectionId);
    return u;
  }

  function formToUrl() {
    const form = getForm();
    let params;
    if (form) {
      params = new URLSearchParams();
      new FormData(form).forEach((v, k) => { if (v !== '') params.append(k, v); });
    } else {
      params = new URLSearchParams(window.location.search);
      const sort = $('[data-sort-select]');
      if (sort) params.set('sort_by', sort.value);
    }
    params.delete('page');
    if (searchSection) {
      // The search section's form carries the built search query – replace it with the typed term.
      params.delete('q');
      params.delete('type');
      params.delete('options[prefix]');
      const term = currentTerm();
      const wasSearching = !!new URLSearchParams(window.location.search).get('q');
      // Collection and search have different sort options.
      if (!!term !== wasSearching) params.delete('sort_by');
      if (term) params.set('q', term);
    }
    const qs = params.toString();
    return qs ? `${basePath}?${qs}` : basePath;
  }

  async function update(href, push = true) {
    const url = toPageUrl(href);
    const results = $('[data-results]', root);
    if (controller) controller.abort();
    controller = new AbortController();
    results.classList.add('is-loading-results');
    try {
      const html = await fetch(toFetchUrl(url), { signal: controller.signal }).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshResults = $('[data-results]', doc);
      const freshForm = $('[data-facets-form]', doc);
      if (freshResults) {
        results.innerHTML = freshResults.innerHTML;
        if (cols) results.querySelectorAll('.product-grid').forEach((g) => g.style.setProperty('--cols-desktop', cols));
      }
      const form = getForm();
      if (freshForm && form) {
        // Keep open/closed state of filter groups.
        const openState = Array.from(form.querySelectorAll('details')).map((d) => d.open);
        form.innerHTML = freshForm.innerHTML;
        form.querySelectorAll('details').forEach((d, i) => { if (openState[i] !== undefined) d.open = openState[i]; });
      }
      if (push) window.history.pushState({ facets: true }, '', url);
    } catch (err) {
      if (err.name !== 'AbortError') window.location.href = url;
    } finally {
      results.classList.remove('is-loading-results');
    }
  }

  const onFormChange = debounce(() => update(formToUrl()), 350);

  document.addEventListener('change', (e) => {
    if (e.target.closest('[data-facets-form]')) onFormChange();
    if (e.target.matches('[data-sort-select]')) {
      const mirror = $('[data-sort-mirror]');
      if (mirror) mirror.value = e.target.value;
      update(formToUrl());
    }
  });

  document.addEventListener('submit', (e) => {
    if (!e.target.matches('[data-facets-form]')) return;
    e.preventDefault();
    update(formToUrl());
  });

  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-facet-link], [data-results] .pagination a');
    if (link) {
      e.preventDefault();
      update(link.getAttribute('href'));
      if (link.closest('.pagination')) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    const opener = e.target.closest('[data-open-facets]');
    if (opener && drawer && drawerBody) {
      const form = getForm();
      if (form) drawerBody.appendChild(form);
      drawer.showModal();
      document.body.classList.add('is-locked');
      drawer.addEventListener('close', () => {
        document.body.classList.remove('is-locked');
        const f = getForm();
        if (f && home) home.appendChild(f);
        opener.focus();
      }, { once: true });
    }
  });

  /* ------------------------------------------------ Singles search (in place) */
  if (singlesInput) {
    const searchForm = singlesInput.closest('form');
    lastTerm = currentTerm();
    const onSearch = debounce(() => {
      const term = currentTerm();
      if (term === lastTerm || term.length === 1) return;
      lastTerm = term;
      update(formToUrl());
    }, 300);
    singlesInput.addEventListener('input', onSearch);
    singlesInput.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && singlesInput.value) {
        singlesInput.value = '';
        onSearch();
      }
    });
    searchForm.addEventListener('submit', (e) => {
      e.preventDefault();
      lastTerm = currentTerm();
      update(formToUrl());
    });

    // Restore a search from the URL (reload, shared link).
    const initial = (new URLSearchParams(window.location.search).get('q') || '').trim();
    if (initial) {
      singlesInput.value = initial;
      lastTerm = initial;
      window.history.replaceState({ facets: true }, '', window.location.href);
      update(window.location.href, false);
    }
  }

  window.addEventListener('popstate', (e) => {
    if (e.state && e.state.facets) {
      if (singlesInput) {
        singlesInput.value = new URLSearchParams(window.location.search).get('q') || '';
        lastTerm = currentTerm();
      }
      update(window.location.href, false);
    } else window.location.reload();
  });
})();
